import Vue from 'vue'

export default {
  loadLayers (workpackId, clbSuccess, clbError) {
    Vue.http.get('/api/layers/list', {
      params: {
        workpack_id: workpackId
      }
    })
      .then(res => {
        clbSuccess(this.sortLayerTree(this.buildLayerTree(res.body)))
      }, res => {
        // Vue.notify({
        //   title: 'ERROR',
        //   text: 'Could not load layers',
        //   type: 'error'
        // })
        clbError(res)
      })
  },
  buildLayerTree (data) {
    let tree = []
    let groups = data['groups']
    for (let k in data) {
      if (k === 'groups') {
        continue
      }
      if (groups[k]) {
        let o = {
          name: groups[k].title,
          group: groups[k],
          children: []
        }
        o['group']['id'] = k
        for (let kl in data[k]) {
          if (data[k][kl]['markers'] && data[k][kl]['markers'].indexOf('profile_app_only') > -1) {
            continue
          }
          data[k][kl]['fields'] = []
          data[k][kl]['hidden'] = false
          o.children.push(data[k][kl])
        }
        tree.push(o)
      } else {
        tree.push(data[k])
      }
    }
    return tree
  },
  sortLayerTree (tree) {
    let walk = (node) => {
      if (node['children']) {
        node['children'] = node['children'].sort((a, b) => {
          if (b['ind'] === a['ind']) {
            return a['data_type'] < b['data_type'] ? -1 : 1
          } else {
            return a['ind'] - b['ind']
          }
        })
        node['children'].forEach(n => walk(n))
      }
    }

    tree.forEach(walk)

    tree = tree.sort((a, b) => {
      let indA = a['group'] ? a['group']['ind'] : a['ind']
      let indB = b['group'] ? b['group']['ind'] : b['ind']
      return indA - indB
    })

    //
    // tree = tree.sort((a, b) => {
    //   let ac = a['children'] ? 0 : 1
    //   let bc = b['children'] ? 0 : 1
    //   return ac - bc
    // })
    return tree
  },
  loadLayerBoundingBox (layer, clb) {
    const wpsXml = `<?xml version="1.0" encoding="UTF-8"?><wps:Execute version="1.0.0" service="WPS" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.opengis.net/wps/1.0.0" xmlns:wfs="http://www.opengis.net/wfs" xmlns:wps="http://www.opengis.net/wps/1.0.0" xmlns:ows="http://www.opengis.net/ows/1.1" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" xmlns:wcs="http://www.opengis.net/wcs/1.1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xsi:schemaLocation="http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsAll.xsd">
  <ows:Identifier>vec:Bounds</ows:Identifier>
  <wps:DataInputs>
    <wps:Input>
      <ows:Identifier>features</ows:Identifier>
      <wps:Reference mimeType="text/xml" xlink:href="http://geoserver/wfs" method="POST">
        <wps:Body>
          <wfs:GetFeature service="WFS" version="1.0.0" outputFormat="GML2" xmlns:v4="v4">
            <wfs:Query typeName="${layer['name']}" cql_filter="${layer['cql']}" srsname="EPSG:3857"/>
          </wfs:GetFeature>
        </wps:Body>
      </wps:Reference>
    </wps:Input>
  </wps:DataInputs>
  <wps:ResponseForm>
    <wps:RawDataOutput>
      <ows:Identifier>bounds</ows:Identifier>
    </wps:RawDataOutput>
  </wps:ResponseForm>
</wps:Execute>`

    Vue.http.post('/api/gs/wps', wpsXml, {
      headers: {
        'Content-Type': 'application/xml'
      }
    }).then(res => {
      clb(null, res.body)
    }, res => {
      clb('Could not get layer bounds')
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/layers.js